module.exports = __webpack_public_path__ + "static/media/gitHub.6248e236.png";